module.exports = __webpack_public_path__ + "img/search-icon.6d6ae2df.svg";